/* eslint-env browser */

import addClass from 'add-class';
import cookies from 'js-cookie';
import removeClass from 'remove-class';

import modalTemplate from '../templates/modal.html';
const Mustache = require('mustache');

class PasswordTakeover {
  /**
   * Constructor.
   * @param {string}          title           Dialog title.
   * @param {string}          prompt          Dialog prompt.
   * @param {string}          error           "Wrong password" error message.
   * @param {PasswordChecker} passwordChecker The password checker.
   * @param {string}          cookieName      The name of the cookie to store the success value.
   */
  constructor({ title, prompt, error, passwordChecker, cookieName }) {
    this.formId = `password-form-${new Date()}`;
    this.passwordChecker = passwordChecker;
    this.cookieName = cookieName;
    this.hideContentClass = 'hide-content';

    this.modalData = { title, prompt, error, formId: this.formId };

    this.render();
    this.addHandlers();
  }

  /**
   * Show the password takeover.
   */
  show() {
    addClass(document.body, this.hideContentClass);
  }

  /**
   * Hide the password takeover.
   */
  hide() {
    removeClass(document.body, this.hideContentClass);
  }

  /**
   * Add event handlers.
   */
  addHandlers() {
    const { formId, cookieName, passwordChecker } = this;

    const modalForm = document.getElementById(formId);
    modalForm.onsubmit = () => {
      // Check the password.
      const passwordInput = document.getElementById('post-password-input');
      if (passwordChecker.checkPassword(passwordInput.value)) {
        this.hide();

        // Set a SESSION cookie.
        cookies.set(cookieName, passwordInput.value, { path: '' });
      } else {
        document.getElementById('post-password-error').style.display = 'block';
      }

      return false;
    };
  }

  /**
   * Render the takeover.
   */
  render() {
    const modalMarkup = modalTemplate(this.modalData);
    const modal = document.createElement('div');
    addClass(modal, 'modal');
    modal.innerHTML = modalMarkup;

    document.body.appendChild(modal);
    this.show();
  }
}

export default PasswordTakeover;
